module.exports = __webpack_public_path__ + "static/media/business_intelligence.aa22cca4.jpg";